/**
 * Base chakra colors rewritten.
 * Here we are trying to follow chakra mental model of colors palette.
 * Unfortunately in initial design colors are slightly different and not ranged
 * properly. To merge our and chakra styled system we used these variants.
 * 500 - of every color is an initial design color from figma.
 * For brand colors, 500 is #1F145D and other variants are generated from it.
 * Rest of them are made by https://themera.vercel.app/ to save a persistent
 * color model.
 * Every components hover, focus and other colors are related to this model.
 * ! Values for hover/focus wasn't initially present in design so colors from
 * themera was picked.
 * ! BrandBlack colors is exception, and they should only be used for brandBlack button variant.
 */
export const colors = {
  colors: {
    // only for black button.
    brandBlack: {
      300: "#2e2d2f",
      400: "#29282a",
      500: "#282729",
    },
    brand: {
      50: "#F0EEF8",
      100: "#E1DDF1",
      200: "#D2CCEA",
      300: "#C3BBE3",
      400: "#B4AADC",
      500: "#1F145D",
      600: "#19104A",
      700: "#130C37",
      800: "#0D0824",
      900: "#070411",
    },
    gray: {
      25: "#F9FAFB",
      50: "#F3F3F3",
      60: "#F4F4F4",
      75: "#F5F5F5",
      100: "#DDDDDD",
      200: "#C4C4C4",
      300: "#E1E1E1",
      400: "#969696",
      500: "#808080",
      600: "#7A7A7A",
      700: "#4D4D4D",
      800: "#333333",
      900: "#1A1A1A",
    },
    red: {
      25: "#FEF2F2",
      50: "#FEE7E7",
      100: "#FBBCBC",
      200: "#F89090",
      300: "#F66565",
      400: "#F33A3A",
      500: "#F44545",
      600: "#C10B0B",
      700: "#900909",
      800: "#600606",
      900: "#300303",
    },
    dark: {
      400: "#22236E",
      500: "#1F145D",
    },
    gold: {
      50: "#FFF9E5",
      100: "#FFF3CC",
      200: "#FFE699",
      300: "#FFDA66",
      400: "#FFCD33",
      500: "#FFC200",
      600: "#CC9B00",
      700: "#997400",
      800: "#664D00",
      900: "#332600",
    },
    purple: {
      25: "#EEF0FF",
      50: "#F4F3FA",
      100: "#E9E7F5",
      200: "#D3CFEB",
      300: "#BDB7E1",
      400: "#A79FD7",
      500: "#918DE2",
      600: "#7471B5",
      700: "#575588",
      800: "#3A385B",
      900: "#1D1C2E",
    },
    green: {
      25: "#ECFDF3",
      50: "#E8F7F0",
      100: "#D1EFE1",
      200: "#BAE7D2",
      300: "#A3DFC3",
      400: "#51BC7E",
      500: "#0B9D58",
      600: "#097D46",
      700: "#075E35",
      800: "#053E23",
      900: "#021F12",
    },
  },
};
